import { UserResource } from '@aorg/models/resources/UserResource';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { PlusIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { BiUser } from 'react-icons/bi';

function UserAvatar({
  profilePic,
  user,
  textClass = 'text-base',
  sizeClass = 'h-12 w-12',
  roundedClass = 'rounded-sm',
  bgClass = 'bg-primary',
  handleUploadImage,
  handleUppyUpload,
  hiddenFileInput,
}: {
  profilePic?: string;
  user?: Partial<UserResource>;
  textClass?: string;
  sizeClass?: string;
  roundedClass?: string;
  bgClass?: string;
  handleUploadImage?: () => void;
  handleUppyUpload?: (files: any) => void;
  hiddenFileInput?: React.RefObject<HTMLInputElement | null>;
}) {
  const [firstLetters, setFirstLetters] = useState('');
  const [onLoadError, setOnLoadError] = useState(false);
  useEffect(() => {
    setFirstLetters('');
    if (isEmpty(user)) return;

    if (!isEmpty(user?.first_name) && !isEmpty(user?.last_name)) {
      setFirstLetters(
        user?.first_name![0]?.toUpperCase() + user?.last_name![0]?.toUpperCase()
      );
    }
  }, [user]);
  return (
    <div>
      {(!isEmpty(user?.profile_picture) || !isEmpty(profilePic)) &&
      !onLoadError ? (
        <img
          className={classNames(roundedClass, sizeClass, 'object-cover')}
          src={profilePic ? profilePic : user?.profile_picture}
          alt={user?.first_name}
          onError={() => setOnLoadError(true)}
        />
      ) : !isEmpty(firstLetters) ? (
        <div
          className={classNames(
            'flex items-center justify-center',
            roundedClass,
            bgClass,
            sizeClass
          )}
        >
          <div
            style={{
              fontWeight: '600',
              flex: 1,
            }}
            className={classNames(
              'w-full text-center content-center',
              // White is unreadable on the default AO yellow background
              bgClass === 'bg-primary' ? 'text-black' : 'text-white',
              textClass
            )}
          >
            {firstLetters}
          </div>
        </div>
      ) : (
        <div
          className={classNames(
            'flex items-center justify-center',
            roundedClass,
            bgClass,
            sizeClass
          )}
        >
          <BiUser className="h-10 w-10" aria-hidden="true" />
        </div>
      )}
      {handleUploadImage && handleUppyUpload && (
        <div className="h-full flex self-center relative">
          <div
            className="absolute p-1 bg-gray-100 rounded-full -right-0 -bottom-0 cursor-pointer"
            onClick={handleUploadImage}
          >
            {!profilePic && !user?.profile_picture ? (
              <PlusIcon className="h-4 w-4 md:h-6 md:w-6" aria-hidden="true" />
            ) : (
              <ArrowPathIcon
                className="h-4 w-4 md:h-6 md:w-6"
                aria-hidden="true"
              />
            )}

            <input
              type="file"
              onChange={(event) => handleUppyUpload(event.target.files)}
              style={{ display: 'none' }}
              ref={hiddenFileInput}
              accept="image/png, image/jpg, image/jpeg"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default UserAvatar;
